<template>
  <div class="page-content_wrapper projects-container">
    <panel title="全部资讯" icon="assets/images/icon-news.png">
      <div v-loading.body="isLoading">
        <template v-if="list.length > 0">
          <news-item
            v-for="(item, index) in list"
            :key="index"
            :value="item"
          />

          <el-pagination
            background
            layout="prev, pager, next, jumper"
            v-bind="pagination"
            @current-change="pageChange"
          />
        </template>

        <empty-layout v-else />
      </div>
    </panel>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import NewsItem from '@/components/NewsItem'
import EmptyLayout from '@/components/EmptyLayout'
import { fetchNews } from '@/api'

export default {

  components: {
    Panel,
    NewsItem,
    EmptyLayout
  },
  data() {
    return {
      list: [],

      pagination: {
        currentPage: 1,
        pageSize: 6,
        total: 0
      },

      isLoading: false
    }
  },

  mounted() {
    this.fetchNews()
  },

  methods: {
    async fetchNews(page = 1) {
      this.isLoading = true

      try {
        const params = {
          pageSize: this.pagination.pageSize,
          pageNo: page
        }

        const res = await fetchNews(params)

        this.list = res.data.records
        this.pagination.currentPage = res.data.current
        this.pagination.total = res.data.total
      } catch (error) {
        this.$message.error(error.message)
      }

      this.isLoading = false
    },

    /*
     * 页数切换
    */
    pageChange(page) {
      document.documentElement.scrollTop = 0
      this.fetchNews(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.projects-container {
  padding-bottom: 48px;
  .el-pagination {
    display: table;
    margin: 50px auto 0;
  }
}
</style>
